
//dibyvai code//

// import React, { useEffect, useState } from "react";
// import { jsPDF } from "jspdf";
// import { ApiUrl } from "../../../ApiUrl";

// const SchoolLeavingCertificate = () => {
//   // const [certificate, setCertificate] = useState(null);
//   const [certificate, setCertificate] = useState(null);

//   // Fetch data from the API and set it in state
//   useEffect(() => {
//     const fetchcertificate = async () => {
//       try {
//         const transferCertificateId = localStorage.getItem(
//           "transfer_certificate_id"
//         );
//         const studentId = localStorage.getItem("studentId");
//         const documentType = localStorage.getItem("documentType");

//         const response = await fetch(
//           `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetCertificatePDF/?transfer_certificate_id=${transferCertificateId}&studentId=${studentId}&documentType=${documentType}`
//         );
//         const data = await response.json();
//         if (data?.message === "success" && data?.data?.length > 0) {
//           setCertificate(data.data[0]);
//         }
//       } catch (error) {
//         console.error("Error fetching certificate data:", error);
//       }
//     };

//     fetchcertificate();
//   }, []);

//   useEffect(() => {
//     if (certificate) {
//       generatePDF(certificate); // Generate the PDF when data is available
//     }
//   }, [certificate]);

//   const generatePDF = () => {
//     if (!certificate) {
//       alert("No certificate data available.");
//       return;
//     }

//     const doc = new jsPDF();

//     const imgWidth = 30;
//     const imgHeight = 30;
//     const imgX = 10;
//     const imgY = 10;
//     doc.addImage(SynergyLogo, "PNG", imgX, imgY, imgWidth, imgHeight);

//     const headingX = 50;
//     const headingY = 15;
//     doc.setFontSize(14);
//     doc.setTextColor(0, 0, 255);
//     doc.setFont("Helvetica", "bold");
//     doc.text(
//       "SYNERGY INSTITUTE OF ENGINEERING & TECHNOLOGY",
//       headingX,
//       headingY
//     );

//     doc.setFontSize(12);
//     doc.setTextColor(0, 0, 0);
//     doc.setFont("Helvetica", "normal");
//     doc.text("Affiliated to", headingX, headingY + 6);
//     doc.text("Affiliation No.:  School Code: SYNERGY", headingX, headingY + 12);
//     doc.text("Tel. No.:", headingX, headingY + 18);
//     doc.text("https://www.synergyinstitute.net/", headingX, headingY + 24);

//     doc.setFontSize(16);
//     doc.setFont("Helvetica", "bold");
//     doc.setTextColor(0, 0, 0);
//     doc.text("School Leaving Certificate", 105, 50, { align: "center" });

//     const tcNumber = `${certificate.transfer_certificate_no_prefix}/${certificate.transfer_certificate_no_postfix}`;
//     doc.setFontSize(10);
//     doc.setFont("Helvetica", "normal");
//     doc.text("Admission No.: 8307246237", 10, 60);
//     doc.text("SRN: ", 105, 60, { align: "center" });
//     // doc.text("TC No.: 1/2024-28", 200, 60, { align: "right" });
//     doc.text(`TC No.: ${tcNumber}`, 200, 60, { align: "right" });

//     // Map the data dynamically
//     const details = [
//       { key: "1. Name of Pupil", value: certificate.studentname || "" },
//       {
//         key: "2. Father's/ Guardian's Name",
//         value: certificate.fathername || "",
//       },
//       { key: "3. Mother's Name", value: certificate.mothername || "" },
//       { key: "4. Nationality", value: certificate.nationality || "" },
//       {
//         key: "5. Whether the candidate belongs to SC/ST/OBC ",
//         value: certificate.category || "",
//       },
//       {
//         key: "6. Date of admission in the school ",
//         value: certificate.school_admission_date,
//       }, // Replace with actual admission date if available
//       {
//         key: "7. Date of birth (in Christian Era) according to the Admission Register",
//         value: certificate.dob || "",
//       },
//       {
//         key: "8. Class in which the pupil/student last studied",
//         value: certificate.student_last_studied || "",
//       },
//       {
//         key: "9. School/ Board Examination last taken with result",
//         value: certificate.school_board_last_taken || "",
//       },
//       {
//         key: "10. Whether failed, if so, once/twice in the same class",
//         value: certificate.whether_failed || "",
//       },
//       {
//         key: "11. Subjects studied",
//         value: certificate.subjects_studied || "N/A",
//       },
//       {
//         key: "12. Whether qualified for promotion to the higher class, if yes, to which class",
//         value: certificate.qualified_for_promotion || "N/A",
//       },
//       {
//         key: "13. Month upto which the pupil/student has paid the school dues",
//         value: certificate.month_fee_paid || "None",
//       },
//       {
//         key: "14. Any Fee Concession availed of:if so, the nature of such concession",
//         value: certificate.fee_concession_availed || "N/A",
//       },
//       {
//         key: "15. Total No. of working days ",
//         value: certificate.total_no_working_days || "N/A",
//       },
//       {
//         key: "16.Total No. of working days present",
//         value: certificate.total_no_working_days_present || "N/A",
//       },
//       {
//         key: "17. Whether NCC Cadet/ Boy Scout/ Girl Guide (details may be given)",
//         value: certificate.ncc_cadet_details || "N/A",
//       },
//       {
//         key: "18. Games played or extra-curricular activities in which the pupil/student usually tool part (mention achievement level only: State or National)",
//         value: certificate.games_played_details || "N/A",
//       },
//       {
//         key: "19. General conduct ",
//         value: certificate.general_conduct || "N/A",
//       },
//       {
//         key: "20. Date of Application for Certificate",
//         value: certificate.tc_applied_date,
//       },
//       {
//         key: "21. Date of Issue of Certificate ",
//         value: certificate.tc_issued_date,
//       },
//       {
//         key: "22. Reasons for leaving the School ",
//         value: certificate.reason_for_tc || "None",
//       },
//       { key: "23. Any other remarks", value: certificate.other_remarks },
//     ];

//     let yOffset = 70;
//     const lineWidth = 80;
//     const valueOffset = 110;

//     details.forEach(({ key, value }) => {
//       doc.setFontSize(10);
//       doc.setTextColor(0, 0, 0);

//       const splitKey = doc.splitTextToSize(key + ":", lineWidth);

//       splitKey.forEach((line, index) => {
//         if (index === 0) {
//           doc.setFont("Helvetica", "normal");
//           doc.text(line, 10, yOffset);

//           doc.setFont("Helvetica", "normal");
//           const splitValue = doc.splitTextToSize(value, 130);
//           splitValue.forEach((lineValue, valueIndex) => {
//             doc.text(lineValue, valueOffset, yOffset + valueIndex * 6);
//           });

//           yOffset += splitValue.length * 6;
//         } else {
//           doc.setFont("Helvetica", "normal");
//           doc.text(line, 10, yOffset);
//           yOffset += 6;
//         }
//       });
//     });

//     const margin = 5;
//     const width = doc.internal.pageSize.width;
//     const height = doc.internal.pageSize.height;

//     yOffset += 8;

//     const dottedLineY = yOffset + 0.5;

//     doc.setLineWidth(0.5);
//     doc.setDrawColor(0, 0, 0);
//     doc.line(margin, dottedLineY, width / 3 - margin, dottedLineY);
//     doc.line(width / 3, dottedLineY, (2 * width) / 3 - margin, dottedLineY);
//     doc.line((2 * width) / 3, dottedLineY, width - margin, dottedLineY);

//     doc.setFontSize(10);
//     doc.text("Prepared by", margin, dottedLineY + 5);
//     doc.text("Checked by", width / 3, dottedLineY + 5);
//     doc.text("Principal", (2 * width) / 3, dottedLineY + 5);

//     doc.setLineWidth(0.5);
//     doc.line(margin, dottedLineY + 10, width - margin, dottedLineY + 10);

//     doc.setFontSize(10);
//     doc.text("For INTER STATE TRANSFER", width / 2 - 30, dottedLineY + 20);

//     doc.setFontSize(10);
//     doc.text("Entries Verified.", margin, dottedLineY + 50);

//     doc.text("Principal", width - margin - 30, dottedLineY + 50);

//     window.open(doc.output("bloburl"), "_blank");
//   };

//   return (
//     <div className="text-center mt-4">
//       {certificate ? (
//         <p>Generating PDF...</p>
//       ) : (
//         <p>Loading certificate data...</p>
//       )}
//     </div>
//   );
// };

// export default SchoolLeavingCertificate;



import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import { ApiUrl } from "../../../ApiUrl";

const SchoolLeavingCertificate = () => {
  useEffect(() => {
    const fetchAndShowPDF = async () => {
      const transferCertificateId = localStorage.getItem(
        "transfer_certificate_id"
      );
      const studentId = localStorage.getItem("studentId");
      const documentType =
        localStorage.getItem("documentType") || localStorage.getItem("document_type");

      const response = await fetch(
        `${ApiUrl.apiurl}STUDENT_CERTIFICATE/GetCertificatePDF/?transfer_certificate_id=${transferCertificateId}&studentId=${studentId}&documentType=${documentType}`
      );
      const data = await response.json();

      if (data?.message === "success" && data?.data?.length > 0) {
        const certificate = data.data[0];
        const doc = new jsPDF();

        doc.addImage("/Assets/sparsh.jpeg", "JPEG", 10, 10, 30, 30);
        doc.setFontSize(14);
        doc.setFont("Helvetica", "bold");
        doc.setTextColor(0, 0, 255);
              doc.text("Sparsh College of Nursing and Allied Sciences", 50, 15);
        doc.setFontSize(12);
        doc.setFont("Helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        doc.text("Affiliated to", 50, 21);
        doc.text("Affiliation No.: School Code: SPARSH", 50, 27);
        doc.text("Tel. No.:", 50, 33);
        doc.text(
          "https://sparshhospitals.com/nursing-college-admission/",
          50,
          39
        );
        doc.setFontSize(16);
        doc.text("School Leaving Certificate", 105, 50, { align: "center" });

        const tcNumber = `${certificate.transfer_certificate_no_prefix}/${certificate.transfer_certificate_no_postfix}`;
        doc.setFontSize(10);
        doc.text("Admission No.: 8307246237", 10, 60);
        doc.text("SRN: ", 105, 60, { align: "center" });
        doc.text(`TC No.: ${tcNumber}`, 200, 60, { align: "right" });

        const details = [
          { key: "1. Name of Pupil", value: certificate.studentname },
          { key: "2. Father's Name", value: certificate.fathername },
          { key: "3. Mother's Name", value: certificate.mothername },
          { key: "4. Nationality", value: certificate.nationality },
          { key: "5. Category", value: certificate.category },
          {
            key: "6. Date of Admission",
            value: certificate.school_admission_date,
          },
          { key: "7. Date of Birth", value: certificate.dob },
          {
            key: "8. Class Last Studied",
            value: certificate.student_last_studied,
          },
          {
            key: "9. Board Exam Result",
            value: certificate.school_board_last_taken,
          },
          { key: "10. Whether Failed", value: certificate.whether_failed },
          { key: "11. Subjects Studied", value: certificate.subjects_studied },
          {
            key: "12. Qualified for Promotion",
            value: certificate.qualified_for_promotion,
          },
          {
            key: "13. Month upto which fees paid",
            value: certificate.month_fee_paid,
          },
          {
            key: "14. Fee Concession",
            value: certificate.fee_concession_availed,
          },
          {
            key: "15. Total Working Days",
            value: certificate.total_no_working_days,
          },
          {
            key: "16. Days Present",
            value: certificate.total_no_working_days_present,
          },
          { key: "17. NCC Details", value: certificate.ncc_cadet_details },
          {
            key: "18. Extra Activities",
            value: certificate.games_played_details,
          },
          { key: "19. Conduct", value: certificate.general_conduct },
          {
            key: "20. Date of Application",
            value: certificate.tc_applied_date,
          },
          { key: "21. Date of Issue", value: certificate.tc_issued_date },
          { key: "22. Reason for Leaving", value: certificate.reason_for_tc },
          { key: "23. Other Remarks", value: certificate.other_remarks },
        ];

        let y = 70;
        details.forEach((item) => {
          const lines = doc.splitTextToSize(
            `${item.key}: ${item.value || "N/A"}`,
            180
          );
          doc.text(lines, 10, y);
          y += lines.length * 6;
        });

        doc.text("Principal", 180, y + 10);

        const pdfBlobUrl = doc.output("bloburl");
        window.location.href = pdfBlobUrl;
      }
    };

    fetchAndShowPDF();
  }, []);

  return null; // No UI needed
};

export default SchoolLeavingCertificate;
